








































import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/mixins/table.mixin';
import Modal from './update-payment.modal.vue';
import { IPaymentBalance } from '@resclick/data-access';
import { i18n } from '@/i18n';

@Component({
  components: {
    Modal,
  },
})
export default class BalancePaymentShell extends Mixins(TableMixin) {
  query = {
    filter: {},
    populate: [
      {
        path: 'order',
        select: ['orderNumber', 'customer'],
        populate: [{ path: 'customer', select: ['name', 'surname'] }],
      },
      { path: 'agent', select: ['name', 'surname'] },
    ],
    currency: i18n.locale,
  };

  filters = [
    { label: this.$i18n.t('GENERAL.VOUCHER'), type: 'number', fieldName: 'orderNumber' },
    {
      label: this.$i18n.t('GENERAL.PAYMENT_DATE'),
      type: 'date-range',
      value: { start: new Date(), end: new Date() },
      fieldName: 'paymentDate',
    },
    {
      label: this.$i18n.t('GENERAL.CHECK_IN'),
      type: 'date-range',
      value: { start: null, end: null },
      fieldName: 'products.checkInDate',
    },
    {
      label: this.$i18n.t('GENERAL.CHECK_OUT'),
      type: 'date-range',
      value: { start: null, end: null },
      fieldName: 'products.checkOutDate',
    },
    {
      label: this.$i18n.t('GENERAL.AGENT'),
      type: 'selectDynamic',
      value: null,
      optionName: (user: any) => {
        return `${user.name} ${user.surname}`;
      },
      clearable: true,
      query: { select: ['name', 'surname'] },
      optionValue: 'id',
      fieldName: 'agent',
      namespace: 'users',
      action: 'find',
    },
  ];

  columns = [
    {
      label: 'GENERAL.ORDER',
      name: 'orderNumber',
      sortable: true,
      field: (row: any) => row.order?.orderNumber,
    },
    {
      label: 'GENERAL.CUSTOMER',
      name: 'customer',
      sortable: true,
      field: (row: any) => `${row.order?.customer?.name || ''} ${row.order?.customer?.surname || ''}`,
    },
    {
      label: 'GENERAL.AGENT',
      name: 'agent',
      sortable: true,
      field: (row: any) => `${row.agent?.name || ''} ${row.agent?.surname || ''}`,
    },
    {
      label: 'GENERAL.BOOKING_DATE',
      name: 'bookingDate',
      sortable: true,
      field: (row: any) => row.order && this.$formatDate(row.order.bookingDate),
    },
    {
      label: 'GENERAL.PAYMENT_DATE',
      name: 'paymentDate',
      sortable: true,
      field: (row: any) => row.paymentDate && this.$formatDate(row.paymentDate),
    },
    {
      label: 'GENERAL.AMOUNT',
      name: 'amount',
      sortable: true,
      field: (row: any) => `${row.amount.toFixed(2) || 0} ${row.currency || ''}`,
    },
    /*
    {
      label: 'GENERAL.DEDUCTION_AMOUNT',
      name: 'amount',
      sortable: true,
      field: (row: any) => `${row.deductionAmount || 0} ${row.currency || ''}`,
    },
    */
    {
      label: 'GENERAL.PAY',
      name: 'pay',
      sortable: true,
    },

    {
      label: 'GENERAL.ACTIONS',
      name: 'actions',
      sortable: true,
    },
  ];

  redirectToPayment(row: IPaymentBalance & { order: string }) {
    this.$router.push({
      name: 'payments-with-balance',
      params: { balancePaymentId: row.id as string, id: (row.order as any).id },
    });
  }

  cleanFilters() {
    this.filters = this.filters.map((f: any) => {
      switch (f.type) {
        case 'number':
          f.value = null;
          return f;
        case 'string':
          f.value = '';
          return f;
        case 'date-range':
          f.value = { start: '', end: '' };
          return f;
        case 'date':
          f.value = { start: '', end: '' };
          return f;
        default:
          return f;
      }
    });
  }
}
